import { hashKey, useQuery } from '@tanstack/react-query';

import { RequestFilters, Template } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface FetchCustomerProps {
  filters?: RequestFilters;
  page?: number;
  pageSize?: number;
}

export const useTemplates = (values?: FetchCustomerProps) =>
  useQuery({
    queryKey: ['templates', hashKey([values])],
    queryFn: async (): Promise<Template[]> => {
      try {
        const { filters, ...otherValues } = values || {};

        const { data } = await request({
          path: `template`,
          method: 'POST',
          authenticate: true,
          dataObject: filters ? values : otherValues,
        });
        return data?.list;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch templates');
      }
    },
    placeholderData: [],
  });
